(function () {
  'use strict';

  if (window.UnifiedTrackingConfig) {
    return;
  }

  window.UnifiedTrackingConfig = {
    version: '2.1.0',

    debug: true,
    consentRequired: true,

    providers: {
      ga4: true,
      clarity: false,
      meta: false,
      tiktok: false,
      linkedin: false
    },

    events: {
      section_view: {
        category: 'engagement',
        service: 'dynamic',
        conversion: false
      },

      phone_grooming: {
        category: 'lead',
        service: 'grooming',
        conversion: true
      },

      phone_hotel: {
        category: 'lead',
        service: 'hotel',
        conversion: true
      },

      phone_veterinar: {
        category: 'lead',
        service: 'veterinar',
        conversion: true
      },

      email_hotel: {
        category: 'lead',
        service: 'hotel',
        conversion: true
      },

      contact_form_submit: {
        category: 'lead',
        service: 'general',
        conversion: true
      }
    },

    pages: {},
    phones: {}
  };
})();
